import React from 'react';
import './Badge.css';

/**
 * Badge Component
 * @param {string} variant - 'success' | 'danger' | 'warning' | 'info' | 'primary' | 'neutral'
 * @param {string} size    - 'sm' | 'md'
 * @param {boolean} dot    - show dot indicator
 */
const Badge = ({ children, variant = 'neutral', size = 'md', dot = false, className = '' }) => {
  return (
    <span className={`badge badge--${variant} badge--${size} ${className}`}>
      {dot && <span className="badge__dot" aria-hidden="true" />}
      {children}
    </span>
  );
};

export default Badge;
